import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  DSM3DatePickerControlAltComponent,
  DSM3DropdownControlComponent,
  DSM3RadioDropdownControlComponent,
} from '@eredes/dsm3';

import { SearchBarViewModel } from 'app/request-form/_models/search-bar.view-model';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SearchBarComponent implements OnInit {
  @Input() viewModel: SearchBarViewModel;
  @Output() searchEvent = new EventEmitter<any[]>();
  currentYear: number;

  @ViewChild('date') datePickerComponent: DSM3DatePickerControlAltComponent;
  @ViewChild('states') statesControl: DSM3DropdownControlComponent;
  @ViewChild('areas') areasControl: DSM3DropdownControlComponent;
  @ViewChild(DSM3RadioDropdownControlComponent) radioComponent: DSM3RadioDropdownControlComponent;

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }

  /**
   * It returns the form control for the input form date
   */
  get getInputFormDateControl(): UntypedFormControl {
    return this.viewModel.formGroup.get('date') as UntypedFormControl;
  }

  /**
   * The function emits for the parent that the form change
   */
  onValueChange(): void {
    this.searchEvent.emit();
  }

  inputDateValueChange(value: Date[]): void {
    if (value.length === 2) {
      this.searchEvent.emit();
    }
  }

  /**
   * Closes dropdownRadioComponent, dropdownComponents and datePickerComponent
   */
  onFocusSearch(): void {
    this.radioComponent.close();
    this.statesControl.close();
    this.areasControl.close();
    this.datePickerComponent.openDatePicker = false;
  }

  /**
   * Closes dropdownRadioComponent and dropdownComponents
   */
  onOpenDatepicker(): void {
    this.radioComponent.close();
    this.statesControl.close();
    this.areasControl.close();
  }

  /**
   * Closes dropdownRadioComponent, datePickerComponent and  dropdowArea
   */
  onOpenDropdownStates(): void {
    this.radioComponent.close();
    this.areasControl.close();
    this.datePickerComponent.openDatePicker = false;
  }

  /**
   * Closes dropdownComponents and datePickerComponent
   */
  onOpenDropdownRadioCategories(): void {
    this.statesControl.close();
    this.areasControl.close();
    this.datePickerComponent.openDatePicker = false;
    this.areasControl.close();
  }

  /**
   * Closes dropdowStates, datePickerComponent and areasDropdownRadio
   */
  onOpenDropdownArea(): void {
    this.radioComponent.close();
    this.statesControl.close();
    this.datePickerComponent.openDatePicker = false;
  }
}
